import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MedicalOrderScann } from '../../../model/medical-order-scann';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MedicalOrderService } from '../../../services/medical-order.service';
import { MedicalOrderScannRequest } from '../../../model/medical-order-scann-request';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { CacheFilterService } from 'src/app/services/cache/cache-filter.service';
import { MedicalOrderScannType } from '../../../model/medical-order-scann-type';
import { AuthService } from 'src/app/services/auth.service';
import { Scanner } from '../../../model/scanner/scanner';
import { ScannerDialogComponent } from '../scanner/scanner-dialog.component';
import { ScannWebSocketService } from '../../../services/scann-web-socket.service';
import { MobileScannAction, MobileScannRequest, MobileScannService } from '../../../services/hub-services/mobile-scann/mobile-scann.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'medical-order-scann-dialog',
  templateUrl: 'medical-order-scann-dialog.component.html',
  styleUrls: ['./medical-order-scann-dialog.component.css'],
  providers: [ ScannWebSocketService ]
  // providers: [MedicalOrderScannHubService]
})
export class MedicalOrderScannDialogComponent implements OnInit, OnDestroy {

  medicalOrderScannTypes: MedicalOrderScannType[];
  restister: boolean;
  connectionError: boolean;
  isClosing: boolean;
  form: FormGroup;
  loadingAction: boolean;
  scanning: boolean;
  scanner: Scanner;
  connected: boolean;

  constructor (public dialogRef: MatDialogRef<MedicalOrderScannDialogComponent>
    , private notificationToastService: NotificationToastService
    , private scannWebSocketService: ScannWebSocketService
    , private mobileScannService: MobileScannService
    , private medicalOrderService: MedicalOrderService
    , private cacheFilterService: CacheFilterService
    , private formBuilder: FormBuilder
    , public dialog: MatDialog
    , private domSanitizer: DomSanitizer
    , private authService: AuthService
    , @Inject(MAT_DIALOG_DATA) public data: MedicalOrderScannRequest) {

      this.form = this.formBuilder.group({
        MedicalsOrderScann: this.formBuilder.array([])
      });

      this.dialogRef.afterClosed().subscribe(() => {
          this.scannWebSocketService.closeConnection();
      });
  }

  get medicalsOrderScann() { return <FormArray>this.form.get('MedicalsOrderScann'); }
  get scannerName(): string { return this.scanner != null ? this.scanner.Name : ''; }
  private subscription: Subscription;

  async ngOnInit() {

    this.loadingAction = false;
    this.isClosing = false;
    this.restister = false;
    this.connectionError = false;

    await this.mobileScannService.subscribe({
      action: MobileScannAction.scannOrder
    });

    this.subscription = this.mobileScannService.imageReceive.subscribe((imageBase64) => {
      this.addImage(imageBase64);
    });

    this.authService.getUserScanner().then((scann) => {
      if (scann) {
        this.scanHubConnect(scann);
      } else {
        this.notificationToastService.error('Usted no tiene un escaner configurado', 'Escaneo de orden');
      }
    });

  }

  private addImage(imageBase64: string): void {
    const row = this.formBuilder.group({
      Id: [''],
      Image64: [imageBase64],
      ImageName: [],
      MedicalOrderId: [this.data.MedicalOrderId],
      MedicalOrderScannTypeId: [this.data.MedicalOrderScannType.Id],
      deleting: [''],
    });
    this.medicalsOrderScann.push(row);
  }

  selectScanner(): void {
    const dialogRef = this.dialog.open(ScannerDialogComponent, {
      width: '50%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  private scanHubConnect(scanner: Scanner): void {

    if (!this.isClosing && scanner) {

      this.scanner = scanner;

      this.cacheFilterService.getMedicalOrderScannTypesFilter().then((items) => {
        this.medicalOrderScannTypes = items;
      });

      this.scannWebSocketService.imageReceived.subscribe((imageBase64) => {
        this.scanning = false;
        this.addImage(imageBase64);
      });

      this.scannWebSocketService.inUseReceived.subscribe(() => {
        this.scanning = false;
        this.notificationToastService.info('El escaner se encuentra ocupado', 'Escaner');
      });

      this.scannWebSocketService.openReceived.subscribe(() => {
        this.connectionError = false;
        this.scanning = false;
        this.connected = true;
      });

      this.scannWebSocketService.errorReceived.subscribe(() => {
        this.connectionError = true;
        this.scanning = false;
      });

      this.scannWebSocketService.closeReceived.subscribe(() => {
        this.scanning = false;
        this.connected = false;
      });

      this.scannWebSocketService.startConnection(scanner);
    }
  }

  sendScann(): void {
    this.scannWebSocketService.sendScann();
  }

  remove(index: number): void {
    this.medicalsOrderScann.removeAt(index);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getImage(index): string {
    return (<MedicalOrderScann>this.medicalsOrderScann.controls[index].value).Image64;
  }



  getSafeUrl(index): SafeUrl {
    const imageBase64 = (<MedicalOrderScann>this.medicalsOrderScann.controls[index].value).Image64;
    return this.domSanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + imageBase64);
  }

  async save() {
    try {
      this.loadingAction = true;
      const medicalOrderScannToUpdate: MedicalOrderScann[] = [];
      let index = 0;
      this.medicalsOrderScann.controls.forEach((control) => {
        const medicalOrderScann = <MedicalOrderScann>control.value;
        medicalOrderScann.Index = index;
        medicalOrderScannToUpdate.push(medicalOrderScann);
        index = index + 1;
      });

      // guardo y actualizo los ids, para no tener que ir y venir con las imagenes
      if (medicalOrderScannToUpdate.length > 0) {
        const response = await this.medicalOrderService.medicalOrderScannUpdate(medicalOrderScannToUpdate);
        medicalOrderScannToUpdate.forEach((item) => {
            const itemUpdated = response.find(r => r.Index === item.Index);
            item.Id = itemUpdated.MedicalOrderScannId;
        });
      }
      this.dialogRef.close(medicalOrderScannToUpdate);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Orden escaneos');
    } finally {
      this.loadingAction = false;
    }
  }

  ngOnDestroy(): void {
    this.mobileScannService.unsubscribe();
    this.subscription.unsubscribe();
  }
}
